import { Locales } from '../localization/locales';

export default {
  [Locales.ru]: {
    vk: 'ВКонтакте',
    link: 'Ссылка',
    linkCopied: 'Ссылка скопирована',
  },
  [Locales.en]: {
    vk: 'VKontakte',
    link: 'Link',
    linkCopied: 'Link copied',
  }
};
